import {Component} from '@angular/core';
import {PlanModelService} from '../../common/service/plan-model.service';
import {isDefined, isUndefined} from '../../common/service/data-util';
import {NgClass} from '@angular/common';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';
import {CompiledFromReference, CompiledFromSetting, compiledFromSettings} from '../../common/models/compiled-from-reference-model';
import {NlrHasPermissionsPipe} from '../../common/pipe/nlr-has-permissions.pipe';
import {NlrPermissionsDisabledPipe} from '../../common/pipe/nlr-permissions-disabled-pipe';
import {NlrFormFieldHasErrorPipe} from '../../common/pipe/nlr-form-field-has-error.pipe';
import {NlrPatternDirective} from '../../common/directive/nlr-pattern.directive';

@Component({
    selector: 'nlr-compiled-from',
    imports: [FormsModule, NgClass, NlrHasPermissionsPipe, NlrPermissionsDisabledPipe, NlrFormFieldHasErrorPipe, NlrPatternDirective],
    templateUrl: './compiled-from.component.html',
    styleUrl: './compiled-from.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class CompiledFromComponent {
    settings: CompiledFromSetting[];

    constructor(private planModelService: PlanModelService) {
        this.settings = compiledFromSettings;
    }

    get readonly() {
        return this.planModelService.readonly;
    }

    title = 'Compiled from  ';

    addCompiledFromReference(source: string) {
        console.debug(this.title + ' controller addCompiledFromReference');
        this.planModelService.getModel().compiledFromReferences.push({source: source, reference: ''});
    }

    removeCompiledFromReference(compiledFromReference: CompiledFromReference) {
        console.debug(this.title + ' controller removeCompiledFromReference');
        const index = this.planModelService.getModel().compiledFromReferences.indexOf(compiledFromReference);
        if (index !== -1) {
            this.planModelService
                .getModel()
                .compiledFromReferences.splice(this.planModelService.getModel().compiledFromReferences.indexOf(compiledFromReference), 1);
        }
    }

    canRemoveReference(compiledFromReference: CompiledFromReference) {
        return this.planModelService.getModel().compiledFromReferences.filter(ref => compiledFromReference.source === ref.source).length > 1;
    }

    canAddReference(compiledFromReference: CompiledFromReference, pattern: string) {
        const regexp = RegExp(pattern);
        return (
            this.planModelService.getModel().compiledFromReferences.filter(function (ref) {
                return (
                    compiledFromReference.source === ref.source &&
                    (isUndefined(compiledFromReference.reference) ||
                        compiledFromReference.reference === null ||
                        compiledFromReference.reference === '' ||
                        !regexp.test(compiledFromReference.reference))
                );
            }).length === 0
        );
    }

    isReferenceProvided() {
        if (
            isDefined(this.planModelService.getModel().compiledFromReferences) &&
            Array.isArray(this.planModelService.getModel().compiledFromReferences) &&
            this.planModelService.getModel().compiledFromReferences.length > 0
        ) {
            return (
                this.planModelService
                    .getModel()
                    .compiledFromReferences.filter(ref => isDefined(ref.reference) && ref.reference != null && ref.reference != '').length > 0
            );
        }
        return false;
    }

    compiledFromReferenceChanged(elementRef: CompiledFromReference) {
        console.debug(this.title + ' controller compiledFromReferenceChanged');
        this.planModelService
            .getModel()
            .compiledFromReferences.filter(
                compiledFromReference => compiledFromReference.reference == elementRef.reference && compiledFromReference.source == elementRef.source
            );
    }

    isDuplicate(ref: CompiledFromReference) {
        const duplicates = this.planModelService
            .getModel()
            .compiledFromReferences.filter(
                compiledFromReference => compiledFromReference.reference === ref.reference && compiledFromReference.source === ref.source
            );
        return duplicates.length > 1;
    }

    setDefaultModel() {
        console.debug(this.title + ' controller setDefaultModel');
        this.planModelService.getModel().compiledFromReferences = [];
    }

    clearModel() {
        this.planModelService.getModel().compiledFromReferences = [];
    }

    getModel() {
        return this.planModelService.getModel();
    }

    getCompiledReferencesBySetting(source: String) {
        return this.planModelService.getModel().compiledFromReferences.filter(ref => ref.source === source);
    }
}
